import SVG from "../../../Components/SVG";
import EditProfileButton from "./EditProfileButton";

export default function PictureCard({ accountData }) {
  return (
    <div className="w-full max-w-3xl rounded-2xl p-4 flex items-start bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="flex gap-7 items-center flex-1 min-w-0">
        <SVG
          name="profilePicture"
          classname="stroke-zi-text-light dark:stroke-zi-text-dark h-fill aspect-square"
        />
        <div className="w-full flex flex-col gap-3 items-start">
          <span className="font-medium text-xl sm:text-2xl text-zi-text-light dark:text-zi-text-dark">
            {accountData && accountData.fn && `${accountData.fn}`}{" "}
            {accountData && accountData.fn && `${accountData.ln}`}
          </span>
          <span className="text-sm sm:text-base text-zi-text-light dark:text-zi-text-dark">
            {localStorage.getItem("email")}
          </span>
        </div>
      </div>

      {/* <EditProfileButton /> */}
    </div>
  );
}
